// extracted by mini-css-extract-plugin
export default {"information":"style_information__8pTt+","info_text":"style_info_text__3Msfi"};